module.exports = function () {
    var $spinner = $('.video-hero-spinner');
    var previousScrollPosition = 0;
    
    var calculateSpinnerPosition = function () {
        var currentHeight = $(window).scrollTop();
        var totalHeight = $(document).outerHeight(true);
        var currentPercent = currentHeight / totalHeight;
        var currentDegrees = (-90 * currentPercent) + 'deg';
        var transformValue = 'rotate(' + currentDegrees + ')';
        $spinner.find('svg').css({
            'transform': transformValue
        });
    };

    if ($spinner.length) {
        setInterval(function () {
            var newScrollPosition = $(window).scrollTop();
            if (newScrollPosition !== previousScrollPosition) {
                calculateSpinnerPosition();
                previousScrollPosition = newScrollPosition;
            }
        }, 10);
    }
};